/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: "load-form",
  formField: {
    city: {
      name: "city",
      label: "Ciudad",
      type: "text",
    },
    type: {
      name: "type",
      label: "Tipo de Almoneda",
      type: "select",
      options: [
        { id: "Primera", label: "Primera" },
        { id: "Segunda", label: "Segunda" },
        { id: "Tercera", label: "Tercera" }
      ],
    }
  },
};

export default form;
